import { TOrganizi8EnvironmentVars } from '@monorepo/types';

export const environment: TOrganizi8EnvironmentVars = {
  appType: 'OT_APP',
  production: false,
  mode: 'kalpha',
  protocol: 'https://',
  service_host: 'organizi8.kalpha.strawmine.com',
  auth_services: '/auth_services/ext',
  unified_login: 'auth.strawmine.com',
  fabric_inspection_services: '/fabric_inspection/ext',
  data_gateway: '/data_gateway/ext',
};
